const BEAD_ROAD_CODES = Object.freeze({
  A: { winner: 'banker', bankerPair: false, playerPair: false },
  B: { winner: 'player', bankerPair: false, playerPair: false },
  C: { winner: 'tie', bankerPair: false, playerPair: false },
  D: { winner: 'banker', bankerPair: true, playerPair: false },
  E: { winner: 'player', bankerPair: true, playerPair: false },
  F: { winner: 'tie', bankerPair: true, playerPair: false },
  G: { winner: 'banker', bankerPair: false, playerPair: true },
  H: { winner: 'player', bankerPair: false, playerPair: true },
  I: { winner: 'tie', bankerPair: false, playerPair: true },
  J: { winner: 'banker', bankerPair: true, playerPair: true },
  K: { winner: 'player', bankerPair: true, playerPair: true },
  L: { winner: 'tie', bankerPair: true, playerPair: true }
});

export function decodeBeadRoadCode(value) {
  const code = String(value || '').trim().charAt(0).toUpperCase();
  const decoded = BEAD_ROAD_CODES[code];
  return decoded ? { code, ...decoded } : null;
}

export const PHASER_BEAD_RESULT_CODES = Object.freeze(['A', 'B', 'C', 'D', 'G', 'J', 'E', 'H', 'K', 'F', 'I', 'L']);
